/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Agri_Unit_PackInputs */

const vi_agri_unit_pack = /** @type {(inputs: Agri_Unit_PackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gói`)
};

/**

* @param {Agri_Unit_PackInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const agri_unit_pack = /** @type {((inputs?: Agri_Unit_PackInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Agri_Unit_PackInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_agri_unit_pack(inputs)
});